<template>
  <Page :response="response">
    <div>
      <InvoiceTabs
        :invoice-hash="invoiceReport.invoice_hash_token"
        :show-payout="true"
        active-tab="Payout"
      />
      <div class="container-fluid">
        <CardForm
          section-title="Payout"
          class="mt-4 mt-md-3 mb-0">
          <div class="invoice-description-table">
            <div class="invoice-table">
              <div class="invoice-table-row px-i">
                <div class="invoice-table-row-start">
                  Invoice Total
                </div>
                <div class="invoice-table-row-end">
                  {{ invoiceReport.invoice_total | formatCurrency(invoiceReport.invoice_currency_iso_code, currencyMinimumDigits) }}
                </div>
              </div>

              <div v-if="invoiceReport.merchant_fawter_fee > 0" class="invoice-table-row px-i">
                <div class="invoice-table-row-start">
                  Fawter Fee {{ vatInclusiveAsterisk }}
                </div>
                <div class="invoice-table-row-end">
                  {{ invoiceReport.merchant_fawter_fee | formatCurrency(invoiceReport.invoice_currency_iso_code, currencyMinimumDigits) }}
                </div>
              </div>

              <div v-if="invoiceReport.merchant_payment_fee > 0" class="invoice-table-row px-i">
                <div class="invoice-table-row-start">
                  Payment Fee
                </div>
                <div class="invoice-table-row-end">
                  {{ invoiceReport.merchant_payment_fee | formatCurrency(invoiceReport.invoice_currency_iso_code, currencyMinimumDigits) }}
                </div>
              </div>

              <div class="invoice-table-row px-i">
                <div class="invoice-table-row-start">
                  NET PAYOUT
                </div>
                <div class="invoice-table-row-end">
                  {{ invoiceReport.merchant_payout | formatCurrency(invoiceReport.invoice_currency_iso_code, currencyMinimumDigits) }}
                </div>
              </div>
            </div>
            <div v-if="invoiceReport.merchant_fawter_fee_vat_rate" class="invoice-table-mention">
              *inclusive of VAT ({{ invoiceReport.merchant_fawter_fee_vat_rate | formatPercentage }})
            </div>
          </div>
        </CardForm>
      </div>
    </div>
  </Page>
</template>

<script>
import store from "./InvoiceStore";
import InvoiceTabs from "./InvoiceShow/InvoiceTabs.vue";
import InvoiceMixin from "./InvoiceMixin";
import CardForm from "../../../shared/components/UI/CardForm.vue";

const responseStore = {
  response: null,
  invoiceReportResponse: null
};

const fetchResource = async (to, from, next) => {
  responseStore.response = await store.fetchPayout(to.params.hash);

  next();
};

export default {
  name: "InvoicePayout",

  components: {
    InvoiceTabs,
    CardForm
  },

  mixins: [InvoiceMixin],

  beforeRouteEnter: fetchResource,
  beforeRouteUpdate: fetchResource,

  data () {
    return {
      responseStore: responseStore,
      store: store
    };
  },

  computed: {
    invoiceReport () {
      return this.responseStore.response.invoiceReport;
    },

    currencyMinimumDigits () {
      if (this.invoiceReport.invoice_currency_iso_code === "LBP") {
        return 0;
      } else {
        return 2;
      }
    },

    vatInclusiveAsterisk () {
      if (this.invoiceReport.merchant_fawter_fee_vat_rate) {
        return "*";
      } else {
        return "";
      }
    }
  },

  mounted () {
    this.addBreadcrumb(`${this.invoiceReport.invoice_merchant_number} - ${this.invoiceReport.invoice_subject} / Payout`);
  }
};
</script>
